import styled from '@emotion/styled'

import { applyMargin, applyWhenHelper } from './helpers'

const Margin = styled.div`
  ${applyMargin}
  ${applyWhenHelper}

  ${({ relative }) => relative && 'position: relative;'}
  ${({ inline }) => inline && 'display: inline-block;'}
`

export default Margin
